export default {
      id: "oc-cephfs-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-cephfs",
      toString: function () {
        return this.url;
      }
    }